import React from "react";
import { useSelector } from "react-redux";
import { i18n } from "../../../app/i18n/i18n";
import { UI_LANG } from "../../../redux/slices/api/initialisePreferences";

export const LanguageProvider = ({ children }) => {
  const lang = useSelector((state) => state.preferences[UI_LANG])[0];
  i18n.setLanguage(lang);

  // re-renders children if language preference changes
  return <React.Fragment key={lang}>{children}</React.Fragment>;
};
